export const checkUserPermissions = (check) => {
    const permissions = JSON.stringify(localStorage.getItem('permissions'));
    if (permissions?.includes(check)) {
        return true;
    }
    else {
        return false;
    }
}